<ca-modal-container modalTitle="{{ title }}" (dismiss)="dismiss()" data-uit="rename-dialog">
    <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
        <div>
            <div class="d-flex flex-column-reverse">
                <input
                    id="name-input"
                    type="text"
                    class="form-control"
                    formControlName="name"
                    required
                    data-uit="rename-confirmation-dialog-input"
                    [ngClass]="formGroup.get('name')?.errors && formGroup.get('name')?.dirty ? 'has-error' : ''"
                />
                <label for="name-input">{{ inputLabel }}</label>
            </div>
            <small *ngIf="formGroup.get('name')?.dirty && formGroup.get('name')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="mt-4">
            <button
                type="submit"
                caAutoFocus
                class="btn btn-primary w-100"
                [disabled]="!formGroup.valid || oldName === formGroup.get('name')?.value"
                (click)="submit()"
                data-uit="rename-confirmation-dialog-btn"
            >
                {{ 'GENERAL.DONE' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
